import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import { STAGE_META, normStage } from "./leadStages";

const ORDER = ["da_valutare", "primo_contatto", "appuntamento_fissato", "appuntamento_svolto", "preventivo_inviato", "vinto", "perso"];

export default function SalesPipeline() {
  const [leads, setLeads] = useState([]);
  const [msg, setMsg] = useState("");

  const load = useCallback(() => {
    api.get("/pipeline").then((r) => setLeads(r.data)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const move = async (lead, stage) => {
    try { await api.put(`/pipeline/${lead.id}`, { stage }); load(); }
    catch (e) { setMsg("Errore: " + (e.response?.data?.detail || e.message)); }
  };
  const remove = async (lead) => {
    if (!window.confirm(`Rimuovere ${lead.name || lead.email} dalla pipeline?`)) return;
    await api.delete(`/pipeline/${lead.id}`); load();
  };

  const byStage = (s) => leads.filter((l) => normStage(l.stage) === s);

  return (
    <div className="panel" data-testid="sales-pipeline-panel">
      <h3>Pipeline conversione lead <Link to="/lead" style={{ fontSize: 13, fontWeight: 400, marginLeft: 8 }} data-testid="pipeline-goto-leads">→ pannello Lead completo</Link></h3>
      <p className="muted" style={{ fontSize: 13, marginTop: 2 }}>
        Chi risponde <strong>"numeri"</strong> alla Lezione 6 riceve in automatico l'email con il link
        per prenotare la mezz'ora ed entra qui. Quando prenota dal link passa a <strong>"Appuntamento fissato"</strong>.
        Clicca sul nome per aprire il percorso completo del lead.
      </p>
      {msg && <p className="muted" style={{ fontSize: 12 }}>{msg}</p>}

      {leads.length === 0 ? (
        <p className="empty" data-testid="pipeline-empty">Nessun lead in pipeline. Appena un iscritto risponde "numeri", comparirà qui.</p>
      ) : (
        <div className="kanban" data-testid="pipeline-board">
          {ORDER.map((s) => {
            const meta = STAGE_META[s];
            const items = byStage(s);
            return (
              <div key={s} className="kanban-col" data-testid={`pipeline-col-${s}`}>
                <div className="kanban-head" style={{ borderTop: `3px solid ${meta.color}` }}>
                  <span>{meta.label}</span>
                  <span className="kanban-count">{items.length}</span>
                </div>
                <div className="kanban-body">
                  {items.map((l) => {
                    const idx = ORDER.indexOf(normStage(l.stage));
                    return (
                      <div key={l.id} className="kanban-card" data-testid={`pipeline-card-${l.id}`}>
                        <div className="kanban-name"><Link to={`/lead/${l.id}`} data-testid={`pipeline-open-${l.id}`}>{l.name || l.email}</Link></div>
                        <div className="kanban-email">{l.email}</div>
                        {l.note && <div className="kanban-note">{l.note}</div>}
                        <div className="kanban-actions">
                          {idx > 0 && (
                            <button className="btn xs" title="Indietro" onClick={() => move(l, ORDER[idx - 1])}
                              data-testid={`pipeline-back-${l.id}`}>←</button>
                          )}
                          {idx < ORDER.length - 1 && normStage(l.stage) !== "vinto" && (
                            <button className="btn xs primary" title="Avanti" onClick={() => move(l, ORDER[idx + 1])}
                              data-testid={`pipeline-next-${l.id}`}>Avanti →</button>
                          )}
                          {normStage(l.stage) !== "perso" && normStage(l.stage) !== "vinto" && (
                            <button className="btn xs danger" title="Perso" onClick={() => move(l, "perso")}
                              data-testid={`pipeline-lost-${l.id}`}>Perso</button>
                          )}
                          <button className="btn xs" title="Elimina" onClick={() => remove(l)}
                            data-testid={`pipeline-del-${l.id}`}>✕</button>
                        </div>
                      </div>
                    );
                  })}
                  {items.length === 0 && <div className="kanban-empty">—</div>}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
